import { FormattedMessage } from 'react-intl';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export const UnknownError = () => (
    <ErrorState
        headline={<FormattedMessage id="intl-msg:fleetstatus.utils.error.unknown.headline" />}
        message={<FormattedMessage id="intl-msg:fleetstatus.utils.error.unknown.message" />}
    />
);
